// @owners { team: patients }
import {
  ONBOARD_STATE_TO_ROUTE,
  type Route,
  type RouteDecisionParams,
  currentStep,
  nextOnboardingRoute,
  previousOnboardingRoute,
} from '~shared/features/onboarding/helpers/onboardingRouteHandler';
import { ROUTE_TO_URL, URL_TO_ROUTE } from '~shared/features/onboarding/helpers/routeToPath';

export function nextUrl({
  params = {},
  currentRoute,
  desiredRoute,
}: {
  params?: RouteDecisionParams;
  currentRoute: Route;
  desiredRoute?: Route;
}): string {
  const nextRoute = nextOnboardingRoute({ params, currentRoute, desiredRoute });

  return ROUTE_TO_URL[nextRoute];
}

export function previousUrl({
  params = {},
  currentRoute,
}: {
  params?: RouteDecisionParams;
  currentRoute: Route;
}): string | null | undefined {
  const previousRoute = previousOnboardingRoute({ params, currentRoute });

  if (previousRoute) {
    return ROUTE_TO_URL[previousRoute];
  }

  return null;
}

export function currentUrlStep({ url }: { url: string }) {
  return currentStep({ route: URL_TO_ROUTE[url] });
}

export function urlFromOnboardState(onboardState: string | null | undefined): string | null | undefined {
  if (onboardState) {
    const route = ONBOARD_STATE_TO_ROUTE[onboardState];

    if (route) {
      return ROUTE_TO_URL[route] || null;
    }
  }

  return null;
}
